"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendedProducts2View = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const RecommendedProduct2View_1 = require("./RecommendedProduct2View");
function DefaultRenderItem({ id, title, images, }) {
    return (0, jsx_runtime_1.jsx)(RecommendedProduct2View_1.RecommendedProduct2View, { id: id, title: title, img: images[0] });
}
function RecommendedProducts2View({ products, carouselProps, }) {
    if (products.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(ui_1.CarouselKeen, Object.assign({ data: products, render: DefaultRenderItem, hideArrows: true, options: {
            breakpoints: {
                [app_1.notDesktop]: {
                    slides: {
                        perView: 1,
                    },
                },
            },
            slides: {
                perView: 'auto',
                spacing: 15,
            },
        }, plugins: [
            ui_1.CarouselKeen.plugins.withRatio(products.map((v) => { var _a, _b; return (_b = (_a = v.images[0]) === null || _a === void 0 ? void 0 : _a.ratio) !== null && _b !== void 0 ? _b : 1; })),
        ] }, carouselProps)));
}
exports.RecommendedProducts2View = RecommendedProducts2View;
